<template>
    <Head title="Comparisons" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <div class="grid grid-flow-col gap-4">
                <div>
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                        Comparisons
                    </h2>
                </div>
                <div class="text-right">
                    <admin-link :href="`/admin/comparisons/create`" title="Create New">Create New</admin-link>
                </div>
            </div>
        </template>
        <BreadCrumbs :items="navItems"></BreadCrumbs>
        <div class="relative w-full py-12 my-6 overflow-hidden shadow">
            <form @submit.prevent="form.get('comparisons')">
                <admin-search-form v-model="form.search"></admin-search-form>
            </form>
            <div class="px-2 md:px-6 pt-2 md:pt-4 pb-2">
                <div class="overflow-x-auto">
                    <div class="inline-block min-w-full overflow-hidden">
                        <table class="min-w-full leading-normal">
                            <thead class="uppercase text-gray-600 text-xs font-semibold bg-gray-200">
                                <tr class="hidden lg:table-row">
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-left text-sm tracking-wider">ID</th>
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-left text-sm tracking-wider">Name</th>
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-left text-sm tracking-wider">Number of comparisons</th>
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-left text-sm tracking-wider">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody class="my-3 flex-1 lg:flex-none">
                                <tr v-if="comparisons.data.length" v-for="comparison of comparisons.data" :key="comparison.id" class="mb-2 lg:mb-0 border-2 lg:border-b-2 border-grey-200 lg:border-t lg:first:border-t-0 flex p-1 md:p-3 hover:bg-gray-100 lg:table-row flex-col w-full flex-wrap">
                                    <td class="p-1 lg:p-5 lg:border-l-2 lg:border-b border-grey-200 bg-white text-sm md:text-base">
                                        <label class="mb-3 bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider block lg:hidden">ID</label>
                                        {{ comparison.id }}
                                    </td>
                                    <td class="p-1 lg:p-5 lg:border-b border-grey-200 bg-white text-sm md:text-base">
                                        <label class="mb-3 bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider block lg:hidden">Name</label>
                                        {{ comparison.name }}
                                    </td>
                                    <td class="p-1 lg:p-5 lg:border-b border-grey-200 bg-white text-sm md:text-base">
                                        <label class="mb-3 bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider block lg:hidden">Number of comparisons</label>
                                        {{ comparison.num_products }}
                                    </td>
                                    <td class="px-5 py-5 lg:border-r lg:border-b border-grey-200 bg-white text-center lg:text-left text-sm md:text-base">
                                        <admin-link :href="'/admin/comparisons/' + comparison.id + '/edit'">Edit</admin-link>
                                        <admin-link type="button" class="bg-red" @click="showDeleteModal(comparison.id)">Delete</admin-link>
                                        <admin-delete-modal v-if="deleteModalIdToShow === comparison.id" :msg="modalMessage" :type="modalType" @toggle-delete-modal="hideDeleteModal()" @delete-item="deleteItem(comparison.id)"></admin-delete-modal>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td class="py-6 bg-red" colspan="4" align="center">
                                        <p class="text-white font-bold">No comparisons found</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <admin-pagination class="mt-6" :links="comparisons.links"></admin-pagination>
                    </div>
                </div>
            </div>
        </div>
        <ToTopLink>To Top</ToTopLink>
    </BreezeAuthenticatedLayout>
</template>
<script>
import AdminSearchForm from "@/Components/Admin/Forms/AdminSearchForm";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import BreezeAuthenticatedLayout from '@/Layouts/Admin/Authenticated.vue';
import {Head, useForm} from '@inertiajs/inertia-vue3';
import AdminLink from "@/Components/Admin/AdminLink";
import AdminDeleteModal from "@/Components/Admin/AdminDeleteModal";
import ToTopLink from "@/Components/Admin/ToTopLink";
import AdminPagination from "@/Components/Admin/AdminPagination";
export default {
    components:
        {
            AdminDeleteModal,
            AdminSearchForm,
            AdminPagination,
            AdminLink,
            BreadCrumbs,
            BreezeAuthenticatedLayout,
            ToTopLink,
            Head,
        },
    data()
    {
        return {
            navItems: [
                { title: 'Comparisons', path: '/admin/comparisons' },
            ],
            deleteModalIdToShow: false,
            modalMessage: 'Are you sure you want to delete this comparison?',
            modalType: 'Comparison',
            form: useForm({
                search: this.term
            })
        }
    },
    props: {
        comparisons: Object,
        term: String
    },
    methods: {
        showDeleteModal(id)
        {
            this.deleteModalIdToShow = id;
        },
        hideDeleteModal()
        {
            this.deleteModalIdToShow = false;
        },
        deleteItem(id)
        {
            this.$inertia.delete('/admin/comparisons/'+id);
        }
    }
}
</script>
